import moment from 'moment-timezone'

export function formatDate(string, format = 'DD/MM/YYYY à\\s HH:mm:ss') {
  if (!string) {
    return ''
  }

  return moment.tz(string, 'UTC').tz(moment.tz.guess()).format(format)
}

export function toUtcIsoString(string) {
  if (!string) {
    return null
  }

  return moment.tz(string, moment.tz.guess()).clone().tz('UTC').toISOString()
}

export function parseDate(data) {
  const [hora, minuto] = data.split(':')

  return [parseInt(hora), parseInt(minuto)]
}

export function parseDateToMinutos(data) {
  const [hora, minuto] = data.split(':')

  return parseInt(hora) * 60 + parseInt(minuto)
}

export function getMs(hora, minutos) {
  const msPorMinuto = 60000
  const msPorHora = 60 * msPorMinuto

  return hora * msPorHora + minutos * msPorMinuto
}

export function extractDateByMonthAndYear(date) {
  const [mes, ano] = date.split('/')

  return new Date(+ano, +mes - 1, 1, 0, 0, 0, 0)
}

export function getOrigemString(tinyint) {
  // Mobile,
  // Web,
  // Automatico

  switch (tinyint) {
    case 1:
      return 'Mobile'
    case 2:
      return 'Web'
    case 3:
      return 'Automático'
    case 4:
      return 'Notificação'
    case 5:
      return 'Calibração'
    default:
      return 'Web'
  }
}

export function getStatusString(tinyint) {
  // EsperandoExecucao,
  // Executado,
  // Cancelado
  // Expirado

  switch (tinyint) {
    case 0:
      return 'Aguardando solicitação do Equipamento'
    case 1:
      return 'Executado'
    case 2:
      return 'Cancelado'
    case 3:
      return 'Enviado para Equipamento'
    case 4:
      return 'Não Enviado'
    case 5:
      return 'Expirado'
  }
}

export function getNotificationIconColor(tinyint) {
  switch (tinyint) {
    case 0:
      return '#2196F3'
    case 1:
      return '#FF9800'
    case 2:
      return '#F44336'
    default:
      return '#000000'
  }
}

export function getNotificationIconName(tinyint) {
  switch (tinyint) {
    case 0:
      return 'info'
    case 1:
      return 'warning'
    case 2:
      return 'error'
    default:
      return 'info'
  }
}

export function getNotificationIconTooltip(tinyint) {
  switch (tinyint) {
    case 0:
      return 'Informação'
    case 1:
      return 'Alerta'
    case 2:
      return 'Erro'
    default:
      return 'Informação'
  }
}
